<template>
  <div class="text-center">
    <v-bottom-sheet v-model="getCotizadorConfigs.dialogNuevaCotizacionEnabled" persistent inset>
      <v-card elevation="8">
        <v-card-title>
          <div class="headline primary--text">Registrar nueva cotización</div>
        </v-card-title>
        <v-card-subtitle>
          <div
            class="caption secondary--text"
          >Número de reporte: {{getActualCotization.NumeroReporte}}</div>
        </v-card-subtitle>
        <v-card-text>
          <v-container fluid>
            <v-layout row>
              <v-flex xs12>
                <div class="py-3 title-1 secondary--text">Datos del cliente:</div>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  style="max-width: 94%; "
                  class="pt-2 autocomplete overline"
                  :items="listaClientes"
                  v-model="getActualCotization.Cliente"
                  label="Cliente"
                  height="18"
                  dense
                  no-data-text="Todas"
                  @change="obtenerClientes"
                ></v-autocomplete>
              </v-flex>

              <v-flex xs8>
                <v-autocomplete
                  class="pt-2 pr-2 autocomplete overline"
                  :items="getInterlocutores.Interlocutores"
                  :item-text="item => `${item.Consignatario} - ${item.Clave} - ${item.codigoPostal} - ${item.Calle}`"
                  label="Interlocutor"
                  item-value="Clave"
                  height="18"
                  v-model="getActualCotization.Interlocutor"
                  single-line
                  no-data-text="Todas"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <div class="py-3 subtitle-1 secondary--text">Datos del vehículo:</div>
              </v-flex>
              <v-flex xs4>
                <v-autocomplete
                  class="pr-2 autocomplete overline"
                  height="18"
                  :items="getMarcas"
                  item-text="marca"
                  item-value="marca"
                  v-model="getActualCotization.VehiculoMarca"
                  label="Marca"
                  x-small
                  dense
                  no-data-text="Todas"
                  @change="obtenerModelos"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  class="autocomplete pr-2 overline"
                  :items="getModelos"
                  height="18"
                  item-text="modelo"
                  item-value="modelo"
                  v-model="getActualCotization.VehiculoModelo"
                  label="Modelo"
                  x-small
                  dense
                  no-data-text="Todas"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs2 height="18">
                <v-autocomplete
                  class="overline"
                  :items="rangoYears"
                  height="18"
                  v-model="getActualCotization.VehiculoYear"
                  label="Año"
                  x-small
                  dense
                  no-data-text="Todas"
                ></v-autocomplete>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions class="d-flex flex-row-reverse pa-3">
          <v-btn
            class="mt-6 ml-2"
            color="primary"
            v-if="this.getActualCotization.VehiculoYear"
            @click="guardarCotizacion"
          >Confirmar</v-btn>
          <v-btn
            class="mt-6"
            color="secondary"
            @click="getCotizadorConfigs.dialogNuevaCotizacionEnabled = false;"
          >Cancelar</v-btn>
        </v-card-actions>
      </v-card>
    </v-bottom-sheet>
  </div>
</template>

<script>
  import { mapGetters } from "vuex";
  export default {
    props: {
      isEnable: Boolean
    },
    computed: mapGetters([
      "userInfo",
      "getMarcas",
      "getModelos",
      "getTaxonomy",
      "getCotizadorConfigs",
      "getActualCotization",
      "getInterlocutores"
    ]),
    data() {
      return {
        listaClientes: ["0001001662", "0001001440", "0001002011", "0001001315"],

        rangoYears: [
          2000,
          2001,
          2002,
          2003,
          2004,
          2005,
          2006,
          2007,
          2008,
          2009,
          2010,
          2011,
          2012,
          2013,
          2014,
          2015,
          2016
        ]
      };
    },
    created() {
      this.$store
        .dispatch("getMarcas")
        .then(() => {})
        .catch(e => {
          console.log(e);
        });

      // this.$store.commit("updateSystemTitle", "Comparativa RADEC - Aldo");
    },
    methods: {
      obtenerClientes() {
        this.getActualCotization.Interlocutor = "";
        this.$store
          .dispatch("getInterlocutores", this.getActualCotization.Cliente)
          .then(e => {})
          .catch(e => {
            console.log(e);
          });
      },
      obtenerModelos() {
        this.selectedModel = "";
        console.log(
          "Obteniendo Modelos " + this.getActualCotization.VehiculoMarca
        );
        this.$store
          .dispatch("getModelos", this.getActualCotization.VehiculoMarca)
          .then(res => {
            console.log(res);
            //this.obtenerQuery();
          })
          .catch(e => {
            console.log(e);
          });
      },
      cancelarRegistro() {
        this.getActualCotization = "";
      },
      guardarCotizacion() {
        console.log(this.userInfo);
        this.getActualCotization.UsuarioRegistraNombre = this.userInfo.Nombre;
        console.log(
          `Has seleccionado: ${this.getActualCotization.UsuarioRegistraNombre} ${this.getActualCotization.Cliente} ${this.getActualCotization.Interlocutor} ${this.getActualCotization.VehiculoMarca} ${this.getActualCotization.VehiculoModelo} ${this.getActualCotization.VehiculoYear}`
        );
        console.log(this.getActualCotization);
        this.$store
          .dispatch("postCotizacion", this.getActualCotization)
          .then(res => {
            console.log("Terminado OK...");
            //Confirmando INFO de Cotizacion Levantada....
          })
          .catch(e => {
            console.log("Error");
            console.log(e);
          });

        this.isEnable = false;
      }
    }
  };
</script>